var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonicIosWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning",
    "data-name": "Icon ionic-ios-warning",
    d: "M38.16,7.564,4.106,69.847A5.857,5.857,0,0,0,9.317,78.5H77.443a5.87,5.87,0,0,0,5.211-8.653L48.581,7.564A5.963,5.963,0,0,0,38.16,7.564Zm8.6,25.842-.692,23.51H40.678l-.692-23.51ZM43.37,69.713a3.548,3.548,0,1,1,3.673-3.546A3.576,3.576,0,0,1,43.37,69.713Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#ffc600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosWarning);
export default __webpack_public_path__ + "static/media/ionic-ios-warning.8d85faccaed30c0329bbf3d629734dc7.svg";
export { ForwardRef as ReactComponent };